import React, { useEffect, useState } from "react";
import { CalendarCheck } from "lucide-react";

export default function StickyBookButton({ onBook }) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const past = window.scrollY > 500;
      const contact = document.querySelector("#contact");
      const inContact = contact
        ? contact.getBoundingClientRect().top < window.innerHeight * 0.6
        : false;
      setShow(past && !inContact);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      className={`lg:hidden fixed bottom-0 inset-x-0 z-40 p-3 pb-[calc(0.75rem+env(safe-area-inset-bottom))] bg-gradient-to-t from-black/20 to-transparent pointer-events-none transition-all duration-300 ${
        show ? "translate-y-0 opacity-100" : "translate-y-full opacity-0"
      }`}
    >
      <button
        onClick={onBook}
        data-testid="sticky-book-consultation-btn"
        className="pointer-events-auto w-full h-12 rounded-full bg-gold hover:bg-gold-dark text-navy font-semibold text-base shadow-lg shadow-black/20 flex items-center justify-center gap-2 transition-colors"
      >
        <CalendarCheck className="h-5 w-5" /> Book a Consultation
      </button>
    </div>
  );
}
